import * as tslib_1 from "tslib";
import { isEqual } from 'lodash';
import { debounce } from 'lodash';
import * as React from 'react';

var DataFetcher =
/** @class */
function (_super) {
  tslib_1.__extends(DataFetcher, _super);

  function DataFetcher() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fetch = function () {
      _this.props.fetch(_this.props.payload);
    };

    _this.getDebouncedFetchFn = function () {
      var fetch = _this.fetch;

      if (_this.props.debounce !== undefined) {
        fetch = debounce(fetch, _this.props.debounce);
      }

      return fetch;
    };

    _this.debouncedFetch = _this.getDebouncedFetchFn(); //tslint:disable-line

    return _this;
  }

  DataFetcher.prototype.componentDidMount = function () {
    this.fetch();
  };

  DataFetcher.prototype.componentDidUpdate = function (prevProps) {
    if (isEqual(prevProps.payload, this.props.payload)) {
      return;
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('Refetching data, payloads are not equal', prevProps.payload, this.props.payload);
    }

    this.debouncedFetch();
  };

  DataFetcher.prototype.render = function () {
    return this.props.children;
  };

  return DataFetcher;
}(React.Component);

export default DataFetcher;